export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14822.b6b554a2.jpg";